import axiosInstance from "../../../configurations/Axios";
import {API_ENDPOINTS} from "../../../constant/APIEndPoints";

export const getAllPlans = async () => {

    try {
        const apiResponse = await axiosInstance.post(API_ENDPOINTS.GET_ALL_PLANS, {
            "request-id": Date.now().toString() + Math.floor(10000 + Math.random() * 90000)
        });
        return apiResponse.data.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
};

export const activateWatch = async (requestPayload) => {
    try {
        const apiResponse = await axiosInstance.post(API_ENDPOINTS.ACTIVATE_WATCH, requestPayload);
        return apiResponse.data;
    } catch (error) {
        console.error(error);
        throw new Error(error);
    }
}